<script>
import appConfig from "@/app.config";

export default {
  page: {
    title: "تفاصيل المسؤول",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "تفاصيل المسؤول",
      items: [
        {
          text: "قائمة المسؤولین",
          to: { name: "admins" },
        },
        {
          text: "تفاصيل المسؤول",
          active: true,
        },
      ],
      record: {},
    };
  },
  mounted() {
    this.fetchRecord();
  },
  methods: {
    fetchRecord() {
      this.$axios.get(`admins/${this.$route.params.id}`).then((res) => {
        this.record = res.data;
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <table class="table table-nowrap mb-0">
              <tbody>
                <tr>
                  <th scope="row" style="width: 400px;">{{ $t("name") }}</th>
                  <td>{{ record.name }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("family") }}</th>
                  <td>{{ record.family }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("email") }}</th>
                  <td>{{ record.email }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("activities") }}</th>
                  <td>
                    <span
                      v-for="(permission, i) in record.permissions"
                      :key="i"
                    >
                      <span v-if="permission.name.startsWith('read')"
                        >منظر {{ permission.fa_title }}</span
                      >
                      <span v-if="permission.name.startsWith('create')"
                        >سجل {{ permission.fa_title }}</span
                      >
                      <span v-if="permission.name.startsWith('update')"
                        >تحریر {{ permission.fa_title }}</span
                      >
                      <span v-if="permission.name.startsWith('delete')"
                        >ازالة {{ permission.fa_title }}</span
                      >
                      <br />
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
